<template>
  <h3>Cover Report TradeMark</h3>
</template>

<script>
export default {
  name: "About",
  data() {
    return {
      message: "Welcome to Vue.js!",
    };
  },
  mounted() {
    this.$hideLoader();
  },
};
</script>

<style scoped></style>
